module.exports = __webpack_public_path__ + "img/new2.0d32a3e6.png";